import type { ReactNode } from 'react';

export const symbol_girl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M437.5-697.6Q420-715.2 420-740.1t17.6-42.4q17.6-17.5 42.5-17.5t42.4 17.6q17.5 17.6 17.5 42.5t-17.6 42.4Q504.8-680 479.9-680t-42.4-17.6ZM420-190v-150h-29q-16 0-24.5-13t-3.5-27l71-208q5-14 17.63-23 12.62-9 28.5-9 15.87 0 28.37 9 12.5 9 17.5 23l71 208q5 14-3.5 27T569-340h-29v150q0 12.75-8.65 21.37-8.64 8.63-21.42 8.63h-60.15q-12.78 0-21.28-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
